import { SentryRoute } from "index";
import AppSwitch from "pages/App/AppSwitch";
import CguRouter from "pages/App/Cgu/CguRouter";
import ConnectSwitch from "pages/Connect/ConnectSwitch";
import MiscRouter from "pages/Misc/MiscRouter";
import PreviewRouter from "pages/Preview/PreviewRouter";
import SsoRouter from "pages/Sso/SsoRouter";
import React from "react";
import { Route, Switch } from "react-router-dom";

const RootSwitch = () => {
  return (
    <Switch>
      <SentryRoute path="/misc" component={MiscRouter} />
      <SentryRoute path="/conditions-generales-utilisation" component={CguRouter} />
      <SentryRoute path="/course/preview/:idPreview" component={PreviewRouter} />
      <SentryRoute path="/sso-retailer" component={SsoRouter} />
      <SentryRoute path="/connect" component={ConnectSwitch} />
      <SentryRoute component={AppSwitch} />
    </Switch>
  );
};

export default RootSwitch;
